import { Pipe, PipeTransform } from '@angular/core';

import { grupoClassificacaoSituacoes } from '../grupo-classificacao-situacao';

@Pipe({
    name: 'grupoClassificacaoSituacaoBadge'
})
export class GrupoClassificacaoSituacaoBadgePipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = grupoClassificacaoSituacoes.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return grupoClassificacaoSituacoes[index].badge;
        }
        return '';
    }
}
